import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  Collapse,
  Grid,
  InputLabel,
  styled,
  TextField,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import { ArrowForward, Close, FilterList } from "@mui/icons-material";
import httpclient from "../../../Utils";

import MuiAlert from "@mui/material/Alert";
import TableComponent from "./TableComponent";
import useTokenRefresh from "../../../Hooks/useTokenRefresh";
import ViewDetails from "./ViewDetails";
import { useBranch } from "../../../Hooks/useBranch";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const columns = [
  { id: "ID", name: "ID" },
  { id: "INM#", name: "INM#" },
  { id: "CODE", name: "Code" },
  { id: "BRANCH", name: "Branch" },
  { id: "QTY_ONHAND", name: "Qty On Hand" },
  { id: "QTY_BACKORD", name: "Qty Backord" },
  { id: "QTY_ONORD", name: "Qty Onord" },
  { id: "QTY_SOLD", name: "Qty Sold" },
].filter(Boolean);

const FilteredBox = styled(Box)(({ theme }) => ({
  background: "#f9f9f9",
  padding: "5px 10px",
  borderRadius: "5px",
  "& p": {
    margin: "0",
    marginRight: "10px",
    display: "inline-block",
    background: "#dedede",
    borderRadius: "10px",
    padding: "2px 5px",
  },
  "& svg": {
    fontSize: "15px",
    cursor: "pointer",
    position: "relative",
    top: "3px",
    background: theme.palette.primary.dark,
    color: "#fff",
    borderRadius: "50%",
    padding: "2px",
    marginLeft: "2px",
  },
}));

const Header = styled("div")(({ theme }) => ({
  "& h1": {
    color: theme.palette.primary.dark,
    margin: "0",
  },
}));

const configRowPerPage = JSON.parse(localStorage.getItem("configRowPerPage"));

const InBrmast = (props) => {
  const {
    getTokenRefreshed: refresh,
    open: tokenOpen,
    overlay: overlay,
    setOpen: setTokenOpen,
    message: tokenMessage,
    messageState: tokenMessageState,
  } = useTokenRefresh();

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewDetails, setViewDetails] = useState({});

  const [rows, setRows] = useState([]);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageState, setMessageState] = useState("");

  const [loading, setLoading] = useState(false);
  const [singleLoading, setSingleLoading] = useState(false);
  const [direction, setDirection] = useState(false);
  const [currentColumn, setCurrentColumn] = useState("");
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [to, setTo] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );

  const [rowsPerPage, setRowsPerPage] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [total, setTotal] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const { currentBranch } = useBranch();

  const [filterData, setFilterData] = useState({
    ID: "",
    "INM#": "",
    CODE: "",
    BRANCH: "",
    QTY_ONHAND: "",
    QTY_BACKORD: "",
    QTY_ONORD: "",
    QTY_SOLD: "",
    remove: false,
  });

  const [submittedData, setSubmittedData] = useState({
    ID: "",
    "INM#": "",
    CODE: "",
    BRANCH: "",
    QTY_ONHAND: "",
    QTY_BACKORD: "",
    QTY_ONORD: "",
    QTY_SOLD: "",
    submit: false,
  });

  useEffect(() => {
    if (
      filterData.ID === "" &&
      filterData["INM#"] === "" &&
      filterData.CODE === "" &&
      filterData.BRANCH === "" &&
      filterData.QTY_ONHAND === "" &&
      filterData.QTY_BACKORD === "" &&
      filterData.QTY_ONORD === "" &&
      filterData.QTY_SOLD === ""
    ) {
      setSubmittedData({
        ...submittedData,
        submit: false,
      });
    }
    if (filterData.ID === " ") filterData.ID = "";
    if (filterData["INM#"] === " ") filterData["INM#"] = "";
    if (filterData.CODE === " ") filterData.CODE = "";
    if (filterData.BRANCH === " ") filterData.BRANCH = "";
    if (filterData.QTY_ONHAND === " ") filterData.QTY_ONHAND = "";
    if (filterData.QTY_BACKORD === " ") filterData.QTY_BACKORD = "";
    if (filterData.QTY_ONORD === " ") filterData.QTY_ONORD = "";
    if (filterData.QTY_SOLD === " ") filterData.QTY_SOLD = "";

    filterData.remove === true && handleFilter();
  }, [filterData]);

  useEffect(() => {
    let userStorage = JSON.parse(localStorage.getItem("inbrmast_filter"));
    userStorage !== null && setFilterData(userStorage);

    userStorage == null
      ? getAllAreas()
      : userStorage.ID === "" &&
        userStorage["INM#"] === "" &&
        userStorage.CODE === "" &&
        userStorage.BRANCH === "" &&
        userStorage.QTY_ONHAND === "" &&
        userStorage.QTY_BACKORD === "" &&
        userStorage.QTY_ONORD === "" &&
        userStorage.QTY_SOLD === "" &&
        userStorage.removed === false
      ? getAllAreas()
      : console.log("inbrmast!");
  }, [currentBranch]);

  const getAllAreas = () => {
    setLoading(true);
    httpclient
      .get(`/sss/inbrmast`)
      .then(({ data }) => {
        if (data.status === 200) {
          setRows(data.data);

          setTotal(data.meta.total);
          setRowsPerPage(parseInt(data.meta.per_page));
          setPage(data.meta.current_page);
          setFrom(data.meta.from);
          setTo(data.meta.to);
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(data.message);
          setMessageState("error");
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const handleFilterOpen = () => {
    setFilterOpen((prev) => !prev);
  };

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterData,
      [name]: value,
      remove: false,
    });
  };

  const handleView = (row) => {
    setSingleLoading(true);
    setOpenViewDialog(true);
    httpclient
      .get(`/sss/inbrmast/${row.ID}`)
      .then(({ data }) => {
        if (data) {
          setViewDetails(data.data);
          setSingleLoading(false);
        } else {
          setOpen(true);
          setMessage(data.message);
          setMessageState("error");
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const sendDetails = (callback) => {
    if (callback.open === false) {
      setOpenViewDialog(false);
      setViewDetails({});
    }
    if (callback.refetch === true) {
      handleView(callback.id);
      setTimeout(() => {
        handleFilter();
      }, 1000);
    }
  };

  const handleFilter = () => {
    setSubmittedData({
      ...submittedData,
      ID: filterData.ID,
      "INM#": filterData["INM#"],
      CODE: filterData.CODE,
      BRANCH: filterData.BRANCH,
      QTY_ONHAND: filterData.QTY_ONHAND,
      QTY_BACKORD: filterData.QTY_BACKORD,
      QTY_ONORD: filterData.QTY_ONORD,
      QTY_SOLD: filterData.QTY_SOLD,

      submit: true,
    });
    filterData.remove = true;
    localStorage.setItem("inbrmast_filter", JSON.stringify(filterData));
    setLoading(true);
    if (
      filterData.ID ||
      filterData.CODE ||
      filterData.BRANCH ||
      filterData.QTY_ONHAND ||
      filterData.QTY_BACKORD ||
      filterData.QTY_ONORD ||
      filterData.QTY_SOLD
    ) {
      httpclient
        .get(
          `sss/inbrmast?filters[CODE][$eq]=${filterData.CODE}&filters[BRANCH][$eq]=${filterData.BRANCH}&pagination=${rowsPerPage}&page=${page}`
        )
        .then(({ data }) => {
          if (data.status === 200) {
            setRows(data.data);

            setTotal(data.meta.total);
            setRowsPerPage(data.meta.per_page);
            setPage(data.meta.current_page);
            setFrom(data.meta.from);
            setTo(data.meta.to);
            setLoading(false);
          } else {
            setOpen(true);
            setMessage(data.message);
            setMessageState("error");
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            refresh();
            setOpen(tokenOpen);
            setMessage(tokenMessage);
            setMessageState("error");
          } else if (err.response.status === 422) {
            const errorMessages = Object.values(
              err.response.data.errors
            ).flat();
            setOpen(true);
            setMessage(errorMessages);
            setMessageState("error");
            setLoading(false);
          } else if (err.response.status === 400) {
            const errorMessages = Object.values(
              err.response.data.errors
            ).flat();
            setOpen(true);
            setMessage(errorMessages);
            setMessageState("error");
            setLoading(false);
          } else {
            setOpen(true);
            setMessage(err.response.data.message);
            setMessageState("error");
            setLoading(false);
          }
        });
    } else {
      getAllAreas();
    }
  };

  const handleRemove = (data) => {
    setFilterData({
      ...filterData,
      [data]: "",
      remove: true,
    });

    setSubmittedData({
      ...submittedData,
      [data]: "",
      remove: true,
    });
  };

  const handleSort = (column) => {
    setDirection((prevDirection) => !prevDirection);
    setCurrentColumn(column);
    setLoading(true);
    submittedData.submit
      ? httpclient
          .get(
            `sss/inbrmast?filters[CODE][$eq]=${
              filterData.CODE
            }&filters[CODE][$eq]=${filterData.CODE}&filters[INM%23][$eq]=${
              filterData["INM#"]
            }&sort[0]=${column}:${
              !direction ? "asc" : "desc"
            }&pagination=${rowsPerPage}&page=${page}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
      : httpclient
          .get(
            `sss/inbrmast?sort[0]=${column}:${
              !direction ? "asc" : "desc"
            }&pagination=${rowsPerPage}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          });
  };

  const handleChangePage = (e, page) => {
    setLoading(true);
    submittedData.submit
      ? httpclient
          .get(
            `sss/inbrmast?filters[DESC][$contains]=${
              filterData.DESC
            }&filters[CODE][$eq]=${filterData.CODE}&filters[CODE][$eq]=${
              filterData.CODE
            }${
              currentColumn
                ? `&sort[0]=${currentColumn}:${direction ? "asc" : "desc"}`
                : ""
            }&pagination=${rowsPerPage}&page=${page}`
          )
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
      : httpclient
          .get(`sss/inbrmast?pagination=${rowsPerPage}&page=${page}`)
          .then(({ data }) => {
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setLoading(true);

    localStorage.setItem("configRowPerPage", event.target.value);

    submittedData.submit
      ? httpclient
          .get(
            `sss/inbrmast?filters[DESC][$contains]=${
              filterData.DESC
            }&filters[CODE][$eq]=${filterData.CODE}&filters[CODE][$eq]=${
              filterData.CODE
            }${
              currentColumn
                ? `&sort[0]=${currentColumn}:${direction ? "asc" : "desc"}`
                : ""
            }&pagination=${+event.target.value}&page=${page}`
          )
          .then(({ data }) => {
            setLoading(true);
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setPage(data.meta.current_page);
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
      : httpclient
          .get(`sss/inbrmast?pagination=${+event.target.value}&page=${page}`)
          .then(({ data }) => {
            setLoading(true);
            if (data.status === 200) {
              setRows(data.data);
              setTotal(data.meta.total);
              setRowsPerPage(parseInt(data.meta.per_page));
              setFrom(data.meta.from);
              setTo(data.meta.to);
              setPage(data.meta.current_page);
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(data.message);
              setMessageState("error");
              setLoading(false);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              refresh();
              setOpen(tokenOpen);
              setMessage(tokenMessage);
              setMessageState("error");
            } else if (err.response.status === 422) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else if (err.response.status === 400) {
              const errorMessages = Object.values(
                err.response.data.errors
              ).flat();
              setOpen(true);
              setMessage(errorMessages);
              setMessageState("error");
              setLoading(false);
            } else {
              setOpen(true);
              setMessage(err.response.data.message);
              setMessageState("error");
              setLoading(false);
            }
          });
  };

  const handleEdit = (row) => {
    setViewDetails(row);
  };

  const handleDelete = (row) => {
    setViewDetails(row);
  };

  // Handle API call to update row status
  const updateRowStatus = (rowId) => {
    //setLoading(true);
    httpclient
      .post(`users/${rowId.id}/status`)
      .then(({ data }) => {
        if (data.status === 200) {
          //setLoading(false);
          setOpen(true);
          setMessageState("success");
          setMessage(data.message);
          setViewDetails({});
          getAllAreas();
        } else {
          //setLoading(false);
          setOpen(true);
          setMessageState("error");
          setMessage(data.error || data.message);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          refresh();
          setOpen(tokenOpen);
          setMessage(tokenMessage);
          setMessageState("error");
        } else if (err.response.status === 422) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          //setLoading(false);
        } else if (err.response.status === 400) {
          const errorMessages = Object.values(err.response.data.errors).flat();
          setOpen(true);
          setMessage(errorMessages);
          setMessageState("error");
          //setLoading(false);
        } else {
          setOpen(true);
          setMessage(err.response.data.message);
          setMessageState("error");
          setLoading(false);
        }
      });
  };

  const currentChange = (value, row) => {
    if (value === "allow_update") {
      handleEdit(row);
    }

    if (value === "allow_delete") {
      handleDelete(row);
    }
  };

  const handleChangeArea = (value) => {
    setFilterData({
      ...filterData,
      ID: value !== null ? value.id : "",
      role_name: value !== null ? value.name : "",
      remove: false,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ID") {
      setFilterData({
        ...filterData,
        role_name: value,
        remove: false,
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setTokenOpen(false);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <Header>
            <h1>In Brmast List</h1>
          </Header>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button
            color="primary"
            variant="contained"
            onClick={handleFilterOpen}
          >
            Filter <FilterList style={{ marginLeft: "5px" }} fontSize="small" />
          </Button>
        </Grid>

        {/* Filter */}
        <Grid item xs={12}>
          <Collapse in={filterOpen}>
            <Card>
              <Box p={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Code</InputLabel>
                    <TextField
                      variant="outlined"
                      name="CODE"
                      value={filterData.CODE}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleFilter();
                      }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Branch</InputLabel>
                    <TextField
                      variant="outlined"
                      name="BRANCH"
                      value={filterData.BRANCH}
                      onChange={handleChangeFilter}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleFilter();
                      }}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box textAlign={"right"}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleFilter}
                      >
                        Filter{" "}
                        <ArrowForward
                          fontSize="small"
                          style={{ marginLeft: "5px" }}
                        />
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Collapse>
        </Grid>

        {submittedData.CODE || submittedData.BRANCH ? (
          <Grid item xs={12}>
            <FilteredBox>
              <span>Filtered: </span>
              {submittedData.CODE && (
                <p>
                  <span>Code: {submittedData.CODE}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("CODE")}
                  />
                </p>
              )}
              {submittedData.BRANCH && (
                <p>
                  <span>Branch: {submittedData.BRANCH}</span>
                  <Close
                    fontSize="small"
                    onClick={() => handleRemove("BRANCH")}
                  />
                </p>
              )}
            </FilteredBox>
          </Grid>
        ) : (
          <Box></Box>
        )}

        <Grid item xs={12}>
          <TableComponent
            name={"In Brmast List"}
            columns={columns}
            rows={rows}
            sort={true}
            handleView={handleView}
            handleSort={handleSort}
            updateRowStatus={updateRowStatus}
            props={props}
            options={props?.permissions}
            currentChange={currentChange}
            loading={loading}
            direction={direction}
            currentColumn={currentColumn}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            page={page}
            total={total && total}
            fromTable={from}
            toTable={to}
            rowsPerPage={rowsPerPage}
          />
        </Grid>
        {/* <Footer overlay={overlay || props.overlayNew} /> */}
      </Grid>

      {openViewDialog && (
        <ViewDetails
          singleLoading={singleLoading}
          viewDetails={viewDetails}
          sendDetails={sendDetails}
        />
      )}

      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open || tokenOpen}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={messageState || tokenMessageState}
          sx={{ width: "100%" }}
        >
          {message || tokenMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default InBrmast;
